import React, { useEffect, useState } from 'react';
import loadjs from 'loadjs';
import Loader from '../common/Loader';
import { setSession, getCookie, getLQWidgetConfig } from '../common/Helpers/index';

const CheckAvailability = () => {
  const [loaderStatus, setLoaderStatus] = useState(true);
  useEffect(() => {
    const loggedIn = getCookie('loggedIn') === 'true';
    const role = getCookie('role');
    const isGuest = role === 'guest';
    let seqType;

    if (loggedIn) {
      if (isGuest) {
        seqType = 'MEC_FWA_NSE'; // Mobility Prospect Order Confirmation Email to FWA with Guest Account.
        setSession('isSequentialFlow', 'Y');
      } else {
        seqType = 'EC_MOC_FWA'; // Mobility Existing Customer Order Confirmation page to FWA.
      }
    } else {
      seqType = 'MOC_FWA'; // Mobility Prospect Order Confirmation page to FWA.
      setSession('isSequentialFlow', 'Y');
    }
    setSession('SeqType', seqType);

    const { lqScriptURL, lqSCURL, vzwlqwidgetconfig } = getLQWidgetConfig('digitalCombo', seqType);
    window.vzwlqwidgetconfig = vzwlqwidgetconfig;

    Promise.all([loadjs(lqScriptURL, { returnPromise: true }), loadjs(lqSCURL, { returnPromise: true })])
      .then(() => {
        const checkWidgetLoaded = () => {
          if (window?.vzlqw?.lqWidgetLoaded) {
            clearInterval(intervalId);
            setLoaderStatus(false);
          }
        };
        const intervalId = setInterval(checkWidgetLoaded, 4);
      })
      .catch((error) => {
        console.error('Error loading LQ scripts:', error);
      });
  }, []);

  return (
    <div>
      <div id="lq-widget-root" />
      <Loader active={loaderStatus} fullscreen={loaderStatus} />
    </div>
  );
};

export default CheckAvailability;
